export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: 'YouJia后台权限管理框架',
    /**
     * @description token在Cookie中存储的天数，默认1天
     */
    cookieExpires: 7,
    //图片地址
    //imgDomain : process.env.NODE_ENV === 'development' ?"http://localhost:6900" : "https://www.qkne.com",
     imgDomain : process.env.NODE_ENV === 'development' ?"https://localhost:6901" : "",
    /**
     * @description api请求基础路径
     */
    //baseUrl : process.env.NODE_ENV === 'development' ?"http://localhost:6900/" : "https://www.qkne.com/",
    baseUrl : process.env.NODE_ENV === 'development' ?"https://localhost:6901/" : "/",
    
    
    
    
  /*   baseUrl: {
      dev: 'http://localhost:6900/',
      pro: 'https://www.qkne.com/', 
      defaultPrefix:"api/v1/"
    }, */
    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName: 'home',
    /**
     * @description 需要加载的插件
     */
    plugin: {
      'error-store': {
        showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
        developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
      }
    }
  }


// WEBPACK FOOTER //
// ./src/config.js